import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import moment from 'moment';

import NotificationComponent from '../inbox/notification-component';
import BookingSmallComponent from './booking-small-renter-component';

import { getBookings } from '../bookings/actions';
import { getFavoriteListings } from '../../user/actions'
import { renderFavoriteListings, renderFavoriteListingsMobile } from './owner-dashboard-component';


const mapStateToProps = state => ({
  user: state.Dashboard.user,
  booking: state.Booking,
  favoriteListings: state.User.favoriteListings
});

class DashboardComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth
    }
  }

  componentWillMount() {
    let { dispatch } = this.props;
    dispatch(getBookings());
    dispatch(getFavoriteListings(this.props.user._id));
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  compareBookings(a, b) {
    let a_startDate = moment(a.startDate);
    let b_startDate = moment(b.startDate)
    if (b_startDate.isBefore(a_startDate)) return 1;
    else if (b_startDate.isAfter(a_startDate)) return -1;
    else return 0;
  }

  filterBookingsList(bookingsList) {
    return bookingsList.filter((b) => moment(b.endDate).isSameOrAfter(moment())
      && b.bookingRequestStatus !== 'Rejected'
      && b.bookingPaymentStatus !== 'Cancelled')
      .sort(this.compareBookings)
      .slice(0, 3);
  }

  renderBookings(bookingsList) {
    return (<div className="booking-small-container">
      {bookingsList.length > 0
        ? bookingsList.map(b => <BookingSmallComponent key={b._id} booking={b} />)
        : (<h5>No Upcoming Bookings</h5>)}
    </div>);
  }

  render() {
    let { user, booking, setActive } = this.props;
    if (!user) return (<div className="container text-center"><h4>Loading...</h4></div>)
    let isMobile = this.state.width <= 576;
    let upcomingBookings = (booking && booking.bookings)
      ? this.filterBookingsList(booking.bookings)
      : [];

    return (<div className="container dashboard-container">
      <div className="row pl-3 align-items-baseline">
        <h1>Welcome, {user.firstName} {user.lastName ? user.lastName.substr(0, 1) : ''}.</h1>
        <Link className="profile-link" to={`/profile/${user._id}`}><span>View / Edit Profile</span></Link>
      </div>
      {user.userType === 'owner' && (
        <div className="row pl-3 mb-3 dashboard-toggle">
          <a><span onClick={() => setActive("owner")}>Switch to Owner Dashboard</span></a>
        </div>
      )}
      <div className="row">
        <div className="col-lg-8">
          <div className="inbox-container">
            <div><h2>Inbox</h2></div>
            <hr />
            <NotificationComponent type="renter" limit={3} />
            <div className="text-right">
              <Link to="/dashboard/inbox">View All Notifications</Link>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="bookings-placeholder">
            <div><h2>Upcoming Bookings</h2></div>
            <hr />
            {this.renderBookings(upcomingBookings)}
            <div className="text-right">
              <Link to="/dashboard/bookings" className='link'>View All Bookings</Link>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-8">
          <div className="favorite-listings-container">
            <div><h2>Favorite Listings</h2></div>
            <hr />
            {isMobile ? renderFavoriteListingsMobile(this.props) : renderFavoriteListings(this.props)}
          </div>
        </div>
      </div>
    </div>);
  }
}

export default withRouter(connect(mapStateToProps)(DashboardComponent));
